import axios from "./api";

const KassaChiqimService = {

    /**
     * data should look like this
     * {
     *   "kassa_id": 1,
     *   "transport_id": 5,
     *   "izoh": "100 litr benzin",
     *   "summa": 150000
     * }
     * @param data
     * @returns {Promise<any>}
     */
    async createKassaChiqim(data) {
        try {
            const response = await axios.post('/kassa_chiqim', data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async updateKassaChiqim(data, id) {
        try {
            const response = await axios.put('/kassa_chiqim/' + id, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async deleteKassaChiqim(id) {
        try {
            const response = await axios.delete('/kassa_chiqim/' + id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
}

export default KassaChiqimService;